import { render, staticRenderFns } from "./JCNumber.vue?vue&type=template&id=1e6adbd6&scoped=true&"
import script from "./JCNumber.vue?vue&type=script&lang=js&"
export * from "./JCNumber.vue?vue&type=script&lang=js&"
import style0 from "./JCNumber.vue?vue&type=style&index=0&id=1e6adbd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6adbd6",
  null
  
)

export default component.exports